module.exports = __webpack_public_path__ + "static/memoji-item-2-950d929feb79c02e8410ccf9a62df70d.png";